import {
    Validator,
    ExtendedFieldId,
    FieldContent,
    ExtendedErrorId,
    setCustomValidator,
} from '@sheerid/jslib';

export const marinerNumberValidator = () => {
    const marinerNumberFieldId: ExtendedFieldId = 'captainsCircleNumber';
    const getMarinerNumberValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const missingError: ExtendedErrorId = 'missingMarinerNumber';
        if (!value) return missingError;

        const tooShortError: ExtendedErrorId = 'shortMarinerNumber';
        if (typeof value === 'string' && value.length < 9) {
            return tooShortError;
        }

        const invalidMarinerNumber: ExtendedErrorId = 'invalidMarinerNumber';
        const VALID_CCN_REGEXPS = [
            /^\d{9}(\d|[A-Z]){0,1}$/g,
        ];
        if (!(VALID_CCN_REGEXPS.some((regexp: RegExp) => regexp.test(value as string)))) return invalidMarinerNumber;

        return null;
    };
    setCustomValidator(marinerNumberFieldId, getMarinerNumberValidationError);
};
